import { ScrollArea } from '@app/shared/ui/atoms/Common';
import { TopBar, Description, BottomNote } from '@app/shared/ui/molecules/DailyCardDescription';
import { CardsDescription } from '@app/shared/ui/organisms/DailyCardDescription';

export default function DailyCardDescriptionPage() {
  return (
    <ScrollArea>
      <TopBar />
      <Description />
      <CardsDescription />
      <BottomNote />
    </ScrollArea>
  );
}
